import { IOneMessageJson } from "../../../../../../nodeserver/structs/database.js";
import { appearingFlexElement, disappearingElement } from "../../../messages/helpers.js";
import JSX from "./../../../helpers/react.js";

export function DeleteSignElement(props: {
    msg: IOneMessageJson,
}){
    const deletedSign = props.msg.deleted ? (
        <div
            className="deleted-message-sign message-action-padding user-message-actions-element deleted-message-action-element appearing-flex-element"
        >
            <img src="/img/delete-message.svg" className="action-element-img"/>
            <span className="main-red-font">Удалено</span>
        </div>
    ) : <></>;

    return deletedSign;
}

export function showDeleteMessageSign(message: HTMLDivElement) {
    const delEL = $(message).find('.deleted-message-sign')

    delEL.addClass(appearingFlexElement).removeClass(disappearingElement);
}

export function hideDeleteMessageSign(message: HTMLDivElement) {
    const delEL = $(message).find(".deleted-message-sign");
    delEL.addClass(disappearingElement).removeClass(appearingFlexElement);
}
